<div class="fullscreen-bg__video">
  <video loop muted autoplay>
    <source src="https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/city.mp4?alt=media&token=035e6673-b7ba-4bf2-9795-d4f5018fa045"
      type="video/mp4">
  </video>
</div>

<div class="content">

  <div class="owl-slider owl-slider-header owl-slider-fullscreen">
    <div class="item">
      <div class="box text-center">
        <div class="container">
          <div class="rating animated" data-animation="fadeInDown">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
          </div>
          <h2 class="title animated h1" data-animation="fadeInDown">
            Empowered21 African Congress Registration
            <br />
            <span>
              <!-- charlitex -->
              <br /> Accommodation, Catering & Transport
            </span>
          </h2>
          <div class="desc animated" data-animation="fadeInUp">
            16th May - 19th May, 2018
          </div>

        </div>
      </div>
    </div>
  </div>


  <section class="booking booking-inner">

    <div class="booking-wrapper">

      <div class="container">
        <div class="row">


          <div *ngIf="!(authService.user | async)" class="col-xs-12 col-sm-4 col-sm-push-4">
            <div class="icon">
              <i class="animated bounce infinite fa fa-arrow-circle-down" style="font-size:40px"></i>
            </div>

            <a [routerLink]="['/register']" class="btn btn-clean">
              Create An Account
              <small>Start Here</small>
            </a>


          </div>

        </div>

      </div>
    </div>
  </section>


  <!-- <section class="frontpage-slider">
    <div class="owl-slider owl-slider-header owl-slider-fullscreen">

      <div class="item">
        <div class="box text-center">
          <div class="container">
            <div class="rating animated" data-animation="fadeInDown">
              <i class="fa fa-star"></i>
              <i class="fa fa-star"></i>
              <i class="fa fa-star"></i>
              <i class="fa fa-star"></i>
            </div>
            <h2 class="title animated h1" data-animation="fadeInDown">
              Empowered21
              <br />
              <span>charlitex accommodation</span>
            </h2>
            <div class="desc animated" data-animation="fadeInUp">
              16th May - 19th May, 2018
            </div>

          </div>
        </div>
      </div>


    </div>

  </section>

        <div *ngIf="!(authService.user | async)" class="col-xs-12 col-sm-4 col-sm-push-4">
          <a [routerLink]="['/register']" class="btn btn-info">
            Create An Account
            <small>Start Here</small>
          </a>
        </div>

      </div>
    </div>
    <!--/booking-wrapper-->
</div>
<!--/container-->
<!-- </section> -->


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/core/components/home/home.component.html